import Constants from '../../../utils/CommonConstants';
import * as _ from 'lodash';
import scopeUtils from '../../../utils/scope';
import { IdleDetectingService } from "../services/IdleDetectingService";
import { commandKeys } from "../../../shared/commandKeys";
import { commandHandlerService } from "../../../services/commandHandlerService";
import { communicationService } from "../../../services/communicationService";
import {utils} from "../../../utils/shopifyInjector/utils";


export class ExternalStoreHandler {
  constructor(scope, rootScope, timeoutService, authenticationService,
    sessionService, cartService, groupOrderService, orderSetupService,
    stateService, messageService, localForageService, heapService, $translate) {
    this._scope = scope;
    this._rootScope = rootScope;
    this._cartService = cartService;
    this._groupOrderService = groupOrderService;
    this._stateService = stateService;
    this._sessionService = sessionService;
    //this._sessionStorageService = sessionStorageService;
    this._localForageService = localForageService;
    this._messageService = messageService;
    this._orderSetupService = orderSetupService;
    this._scope.needAddItem = false;
    this._authenticationService = authenticationService;
    this._heapService = heapService;
    this.timeoutService = timeoutService;
    this.$translate = $translate;

    this._scope.variantId = null;
    this._scope.quantity = null;
    this.isMobile = /iphone|android/gi.test(navigator.userAgent);

    this.idleTimeBeforeRefreshing = this.isMobile ? 5 : 15; // minutes

    this._scope.$on(Constants.Events.ORDER_CREATED, async () => this._onOrderSetupFinished());
    this._scope.$on(Constants.Events.ORDER_CANCELLED, async () => this._onOrderCancelled());
    this._scope.$on(Constants.Events.LEFT_ORDER, async () => this._onParticipantLeftOrder());

    this._scope.$on(Constants.Events.USER_LOGGED_IN, async (scope, registration) => this._onUserLoggedIn(registration));
    this._scope.$on(Constants.Events.USER_LOGGED_OUT, () => this._onUserLoggedOut());
    this._scope.$on(Constants.Events.INVITATION_ACCEPTED, () => this._onInvitationAccepted());
    this._scope.$on(Constants.Events.CART_ITEMS_CHANGED, () => this._onProductItemsChanged());
    this._scope.$on(Constants.RootEvents.USER_PROFILE_UPDATED, () => this._onUserProfileChanged());
    this._scope.$on(Constants.Events.EXTERNAL_PRODUCT_DETAIL_REQUESTED, (scope, shopifyProductUrl) => this._onProductDetailRequested(shopifyProductUrl));
    this._scope.$on(Constants.Events.ORDER_CANCELLED_BY_OWNER, _.debounce(() => this._onOrderCancelledByOwner(), 300));
    this._scope.$on(Constants.Events.ORDER_CLEARED_BY_OWNER, _.debounce(() => this._onOrderClearedByOwner(), 300));
    this._scope.$on(Constants.Events.USER_REMOVED_BY_OWNER, _.debounce(() => this._onUserRemovedByOwner(), 300));
    this._scope.$on(Constants.Events.ORDER_CHECKED_OUT, _.debounce(() => this._onOrderCheckedOut(), 300));
    this._scope.$on(Constants.Events.CART_OWNERSHIP_TRANSFERRED, _.debounce((scope, obj) => this._onOwnershipTransferred(obj), 300));
    this._scope.$on(Constants.Events.USER_JOINED_OTHER_CART, _.debounce((scope, obj) => this._onUserJoinedOtherCart(obj), 300));

    this._scope.$on(Constants.RootEvents.CART_CHANGED, async () => await this._onCartChanged());

    this._rootScope.toggleWindowState = (e) => this._toggleWindowState("", e);
    this._rootScope.enlargeWidget = (e) => this._enlargeWidget();
    this._rootScope.collapsed = !stateService.is(Constants.RoutingStates.CONFIRM_TICKET) &&
        !stateService.is(Constants.RoutingStates.INVITE) && !stateService.is(Constants.RoutingStates.LOGIN_TICKET) && !rootScope.safariWarningIsShowing;

    this._scope.externalStoreWindowTitle = ``;
    this.canAddCurrentProduct = false;

    this._scope._createGroupOrder = () => this._createGroupOrder();
    this._scope.createGroupOrderIfNeeded = (e) => this._createGroupOrderIfNeeded(e);
    this._scope.toggleChat = () => this._toggleChatPage();
    this._scope.toggleOrderPage = () => this._toggleOrderPage();
    this._scope.toggleProfilePage = () => this._toggleProfilePage();
    this._scope.toggleInvitedPeoplePage = () => this._toggleInvitedPeoplePage();
    this._scope.showVersionPage = () => this._showVersionPage();
    this._scope.isOrderFreezed = false;

    this._rootScope.canAddCurrentProduct = () => this.canAddCurrentProduct;
    this._rootScope.addCurrentProduct = () => this.addCurrentProduct();

    this.addProductToCartHandler = {
      command: commandKeys.addProductToCart,

      handle: async (request, sender, sendResponse) => {
        await this.onProductAddRequested(request, sendResponse);
      }
    };

    this.windowStateChangeCommandHandler = {
      command: commandKeys.windowStateChange,

      handle: (request, sender, sendResponse) => {
        this.onWindowStateChanged(request, sendResponse);
      }
    };

    this.canAddCurrentProductHandler = {
      command: commandKeys.addToCartButtonDetected,

      handle: (request, sender, sendResponse) => {
        this.canAddCurrentProduct = true;
      }
    };

    this.checkProductCartCapabilityHandler = {
      command: commandKeys.checkProductCartCapability,

       handle: async (request, sender, sendResponse) =>  {
        let cart = await this._cartService.getCart(undefined , request.data &&  request.data.fromCache);
        console.log(cart);
      }
    };

    this.moneyFormatChangeHandler = {
      command: commandKeys.moneyFormatChange,

      handle: async (request, sender, sendResponse) =>  {
        console.log(request.data.moneyFormat);
        this._rootScope.moneyFormat = request.data.moneyFormat;
      }
    };

    this.translationsHanler = {
      command: commandKeys.getTranslations,

      handle: async (request, sender, sendResponse) =>  {
        sendResponse(this.$translate.getTranslationTable());
      }
    };

    commandHandlerService.registerHandler(this.addProductToCartHandler);
    commandHandlerService.registerHandler(this.windowStateChangeCommandHandler);
    commandHandlerService.registerHandler(this.canAddCurrentProductHandler);
    commandHandlerService.registerHandler(this.checkProductCartCapabilityHandler);
    commandHandlerService.registerHandler(this.moneyFormatChangeHandler);
    commandHandlerService.registerHandler(this.translationsHanler);

    this._lastSessionState = null;
  }

  static toPossessiveString(name) {
    if (name[name.length - 1] === 's') {
      return `${name}'`;
    }

    return `${name}'s`;
  }

  async initialize() {
    new IdleDetectingService((idleTime) => this._onUserActiveAfterIdle(idleTime));
    window.parent.postMessage({
      checkWindowState: true,
      cartonomyInitialized: true,
      retailer: this._scope.retailer
    }, '*');

    communicationService.requestToParent(commandKeys.widgetInitialized, {});

    if (this._stateService.is(Constants.RoutingStates.CONFIRM_TICKET)) {
        await this._stateService.go(Constants.RoutingStates.CONFIRM_TICKET);
        return;
    }

    this._lastSessionState = await this._localForageService.retrieve(Constants.SessionStorage.LAST_STATE_NAME);
    if (this._lastSessionState && this._lastSessionState !== "invite") {
      await this._stateService.go(this._lastSessionState);
    }
    
    let self = this;
    this._rootScope.$on('$stateChangeStart',
        function (event, toState) {
          if (toState.name !== Constants.RoutingStates.CHECKOUT_FULL_MIXED) {
            self._localForageService.store(Constants.SessionStorage.LAST_STATE_NAME, toState.name).then(() => {
            });
          }
        });

    if (!(await this._sessionService.loggedIn())) {
      await this._sendUserCartInfoToParent();
      window.parent.postMessage({
        orderExists: false,
        retailer: this._scope.retailer
      }, '*');

      if (!this._stateService.is(Constants.RoutingStates.LOGIN_TICKET)) {
        await this._goToCart();
      }
      return;
    }

    if (this._stateService.is(Constants.RoutingStates.INVITE)) {
      this._scope.$on(Constants.Events.INVITATION_ACCEPTED, () => this._onUserLoggedIn(true));
      return;
    }

    if (!this._stateService.is(Constants.RoutingStates.LOGIN_TICKET)) {
      await this._onUserLoggedIn();
    }
  }

  addCurrentProduct() {
    communicationService.requestToParent(commandKeys.addProductToCart, {});
  }

  async onProductAddRequested(request, sendResponse) {
    if (this._addingProduct)
      return;

    //Check Stealth mode
    let isStealthMode = this._sessionService.getStealthUserMode();
    if(isStealthMode){
      await this._messageService.showErrorPopup(this.$translate.instant('client.user.cart_restrict'));
      window.parent.postMessage({
        addProductDone: true
      }, '*');
      return;
    }

    const qty = request.data.quantity || 1;

    let cart = await this._cartService.getCart(undefined);
    if (cart.retailerStoreId && request.data.storeId !== cart.retailerStoreId) {
      this._messageService.showErrorPopup(this.$translate.instant('client.user.product_restrict'));
      window.parent.postMessage({
        addProductDone: true
      }, '*');
      return;
    }
    await this._onProductVariantReceived(request.data.productVariantId,
      qty,
      request.data.productName,
      request.data.productImage,
      request.data.productPrice,
      request.data.productOptions,
      request.data.productUrl);

    scopeUtils.apply(this._scope);
  }

  onWindowStateChanged(event, sendResponse) {
    this._rootScope.collapsed = event.data.windowState === Constants.WindowMode.minimized;

    this._rootScope.currentWindowState = event.data.windowState;
    this._rootScope.$broadcast(Constants.Events.WINDOW_STATE_CHANGED, event.data.windowState);

    if (!this._rootScope.collapsed) {
      if (this._rootScope.orderCreationCancelRequested) {
        this._rootScope.orderCreationCancelRequested = false;
        this._goToCart();
      } else if (!this._scope.isProfile() &&
        !this._scope.isChat() &&
        !this._stateService.is(Constants.RoutingStates.INVITE) &&
        !this._stateService.is(Constants.RoutingStates.INVITED_PEOPLE) &&
        !this._stateService.is(Constants.RoutingStates.STORE_ADMIN) &&
        !this._stateService.is(Constants.RoutingStates.OPEN_CARTS) &&
        !this._stateService.is(Constants.RoutingStates.LOGIN_TICKET) &&
          !this._stateService.is(Constants.RoutingStates.CONFIRM_TICKET)) {
        this._goToCart();
      }
    }

    scopeUtils.apply(this._scope);
    sendResponse({
      status: "onWindowStateChanged: event handled"
    });
  }

  async _onProductVariantReceived(productVariantId, quantity, productName, productImage, productPrice, productOptions, productUrl) {
    this._scope.variantId = productVariantId;
    this._scope.quantity = quantity;
    this._scope.productName = productName;
    this._scope.productImage = productImage;
    this._scope.productPrice = productPrice;
    this._scope.productOptions = productOptions;
    this._scope.productUrl = productUrl;

    await this._checkGroupOrder();

    if (await this._sessionService.loggedIn() && this.orderExists) {
      await this.addItemToCart();
      return;
    } else {
      this._scope.needAddItem = true;
      if (this._orderBeingCreated)
        return;

        this._toggleWindowState("addProductTrigger");
        window.parent.postMessage({
            addProductDone: true
        }, '*');

      await this._setupNewOrder(this._scope.needAddItem);
    }
  }

  async _onUserJoinedOtherCart(obj) {
    if (!this._rootScope.forceInvite) {
      await this._messageService.showMessagePopup(this.$translate.instant('client.order.joined_diff_group'));
    }
    this._rootScope.forceInvite = false;
    this._sessionService.setCartReference(null);
  }

  async _onOrderSetupFinished() {
    if (this._scope.needAddItem) {
        if(!this.orderExists){
          try {
            await this._stateService.go(Constants.RoutingStates.USER_PROFILE);
          } catch (e) {
            console.log(e);
          }
        }
        // this._sessionStorageService.set(Constants.LAST_STATE_NAME, Constants.SessionStorage.CART);
        setTimeout(() => this._goToCart(), 10);
        await this.addItemToCart();
    } else {
      this._goToChatPage();
    }
    await this._checkGroupOrder();
    await this._sendUserCartInfoToParent();
  }

  _goToChatPage() {
    this._stateService.go(Constants.RoutingStates.CHAT);
  }

  async _onUserLoggedOut() {
    window.parent.postMessage({
      userDetails: {
        userFirstName: null,
        hasCart: null
      },
      orderExists: false,
      retailer: this._scope.retailer
    }, '*');
    this._scope.externalStoreWindowTitle = this.$translate.instant('client.auth.signin');
    await this._checkGroupOrder();
    await this._sendUserCartInfoToParent();
  }

  _toggleWindowState(trigger, e) {
    if (trigger === "")
      trigger = "titleBar";
    window.parent.postMessage({
      toggleWindowState: true,
      toggleWindowTrigger: trigger
    }, '*');
  }

  _enlargeWidget(e){
      this._rootScope.enlarged = !this._rootScope.enlarged;
      window.parent.postMessage({
          enlargeWidgetState: true,
          enlargeTrigger: this._rootScope.enlarged ? 'enlarge' : 'decrease'
      }, '*');
  }

  _toggleChatPage() {
    this._scope.showChat();

    if (this._rootScope.collapsed) {
      this._toggleWindowState("chat");
    }

    this._cancelOrderCreationDialogIfNeeded();
  }

  _createGroupOrder() {
    this._goToCart();

    if (this._rootScope.collapsed)
      this._toggleWindowState("createOrder");
  }

  _createGroupOrderIfNeeded(e) {
    if (this._rootScope.collapsed)
      this._toggleWindowState("");
    // if(this._scope.groupOrderCreated) {
    //   return;
    // }
    // let trigger = "createOrder";
    // if (e != undefined && e.srcElement != undefined && e.srcElement.outerText == "My Group Order")
    //   trigger = "titleBar";
    // if (this.orderExists) {
    //   return;
    // }else{
    //   this._cartService.resetCartInvitationType();
    //   this._rootScope.$broadcast(Constants.Events.OPEN_SPLASH_SCREEN);
    // }
    //
    // this._goToCart();
  }

  _toggleOrderPage() {
    if(this._scope.isOrderFreezed) {
      return;
    }
    if (!this.orderExists) {
      this._cartService.resetCartInvitationType();
      this._rootScope.$broadcast(Constants.Events.OPEN_SPLASH_SCREEN);
    }

    this._scope.onCartBagClicked();

    if (this._rootScope.collapsed)
      this._toggleWindowState("cartBag");

    //this._cancelOrderCreationDialogIfNeeded();
  }

  _toggleProfilePage() {
    this._scope.showAccount();

    this._cancelOrderCreationDialogIfNeeded();

    if (this._rootScope.collapsed) {
      this._toggleWindowState("profile");
    }
  }

  _showVersionPage() {
    this._stateService.go(Constants.RoutingStates.ABOUT);

    this._cancelOrderCreationDialogIfNeeded();

    this._rootScope.$broadcast(Constants.Events.VERSION_PAGE_REQUESTED);

    if (this._rootScope.collapsed) {
      this._toggleWindowState("version");
    }                  
  }

  _toggleInvitedPeoplePage() {
    this._scope.showInvitedPeople();

    if (this._rootScope.collapsed) {
      this._toggleWindowState("invitedPeople");
    }

    this._cancelOrderCreationDialogIfNeeded();
  }

  _cancelOrderCreationDialogIfNeeded() {
    if (this._orderSetupService.orderSetupDialogShowing) {
      this._rootScope.orderCreationCancelRequested = true;
      this._rootScope.$broadcast(Constants.Events.ORDER_CREATION_CANCEL_REQUESTED);
    }
  }

  async _onOrderCancelled() {
    await this._scope.showAccount();
    this._sessionService.setCartReference(null);
    await this._onUserLoggedIn();
  }

  async _onOrderCancelledByOwner() {
    this._scope.isOrderFreezed = true;
    await this._scope.showAccount();
    this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_cancelled'));
    this._sessionService.setCartReference(null);
    await this._goToCart();
    this._scope.isOrderFreezed = false;
  }

  async _onOrderClearedByOwner(){
    this._scope.isOrderFreezed = true;
    await this._scope.showAccount();
    this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_cleared'));
    this._sessionService.setCartReference(null);
    await this._onUserLoggedIn(false, true);
    this._scope.isOrderFreezed = false;
  }

  async _onUserRemovedByOwner() {
    this._scope.isOrderFreezed = true;
    await this._scope.showAccount();
    this._messageService.showMessagePopup(this.$translate.instant('client.order.owner_removed'));
    this._sessionService.setCartReference(null);
    await this._goToCart(false, true);
    this._scope.isOrderFreezed = false;
  }

  async _onOrderCheckedOut() {
    this._scope.isOrderFreezed = true;
    await this._scope.showAccount();
    let messageText = this.$translate.instant('client.order.owner_closed');

    if (this.isOwner) {
      messageText = this.$translate.instant('client.order.owner_fulfilled');
    }
    await this._messageService.showMessagePopup(messageText);
    this._sessionService.setCartReference(null);
    await this._onUserLoggedIn(false, true);
    this._scope.isOrderFreezed = false;
  }

  async _onParticipantLeftOrder() {
    await this._onUserLoggedIn();
  }

  async _onUserLoggedIn(fromInvitation, forceGoTCart) {
    await this._checkGroupOrder();
    await this._sendUserCartInfoToParent();

    if (forceGoTCart || (!fromInvitation && !this._lastSessionState)) {
      await this._goToCart();
    }
  }

  async _onUserProfileChanged() {
    await this._checkGroupOrder(false);
    await this._sendUserCartInfoToParent();
  }

  async _goToCart() {
    await this._stateService.go(Constants.RoutingStates.CART);
  }

  async _sendUserCartInfoToParent() {
    let cartOwner = this.orderExists ? _.find(this.cart.participants, participant => participant.status === `OWNER`) : null;

    let currentEmail = await this._sessionService.getUserEmail();
    let isOwner = cartOwner && cartOwner.email === currentEmail;
    this.isOwner = isOwner;

    this.timeoutService(async () => {
      if (cartOwner && cartOwner.name) {
        let cartName = 'My Group Order';
        if(this._scope.retailer.customCartNames === '1' && this.cart.cartName && this.cart.cartName !== Constants.CART_NAME_DEFAULT_VALUE){
            cartName = this.cart.cartName;
        }
        if (this.isMobile) {
          this._scope.externalStoreWindowTitle = this.$translate.instant('client.group_order');
        } else if (!isOwner) {
			let getFirstName = await this._sessionService.getUserFirstName();
          let name = (cartOwner && cartOwner.name || getFirstName);
          if(this._scope.retailer.customCartNames === '1' && this.cart.cartName && this.cart.cartName !== Constants.CART_NAME_DEFAULT_VALUE){
              name = this.cart.cartName;
          }else{
              name = this.$translate.instant('client.user.in_order', {name: ExternalStoreHandler.toPossessiveString(name)});
          }
          this._scope.externalStoreWindowTitle = `${name}`;
        } else {
          this._scope.externalStoreWindowTitle = `${cartName}`;
        }
      } else {
        if(await this._sessionService.loggedIn()){
            this._scope.externalStoreWindowTitle = this.$translate.instant(utils.externalStoreWindowTitle);
        }else {
            this._scope.externalStoreWindowTitle = this.$translate.instant('client.auth.signin');
        }      }
    }, 300);

    communicationService.requestToParent(commandKeys.userLoggedIn, {
      cartOwnerName: cartOwner && cartOwner.name,
      isOwner: isOwner,
      hasCart: this.orderExists
    });

    window.parent.postMessage({
      userDetails: {
        userFirstName: await this._sessionService.getUserFirstName(),
        cartOwnerName: cartOwner && cartOwner.name,
        isOwner: isOwner,
        hasCart: this.orderExists,
        customCartNames: this._scope.retailer.customCartNames,
        cartName: this.cart ? this.cart.cartName : ""
      }
    }, '*');
  }

  _onProductDetailRequested(shopifyProductUrl) {
    window.parent.postMessage({
      requestDetailPage: {
        shopifyProductUrl: shopifyProductUrl
      }
    }, '*');
  }

  async addItemToCart() {
    await this._checkGroupOrder();
    if (this._addingProduct || !this.orderExists)
      return;

    this._addingProduct = true;
    try {
      this._rootScope.addingProduct = {
        variantId: this._scope.variantId,
        quantity: this._scope.quantity
      };

      if (!this._scope.productName && !this._scope.productImage) {
        await this._cartService.addProductFromShopify(this._scope.variantId, this._scope.quantity, this._scope.productOptions);
      } else {
        await this._cartService.addProductFromCustomSite(this._scope.variantId, this._scope.quantity, this._scope.productName, this._scope.productImage, this._scope.productPrice, this._scope.productOptions, this._scope.productUrl);
      }

      scopeUtils.apply(this._scope);

        this._goToCart()
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);

      window.parent.postMessage({
        closeWindow: true
      }, '*');
    } finally {
      window.parent.postMessage({
        addProductDone: true
      }, '*');
      this._addingProduct = false;
      this._scope.needAddItem = false;
    }
  }

  async _checkGroupOrder(fromCache = true) {
    this.cart = await this._cartService.getCart(undefined ,fromCache);
    this.orderExists = await this._cartService.isGroupOrder();
    this._rootScope.orderExists = this.orderExists;

    window.parent.postMessage({
      orderExists: this.orderExists,
      retailer: this._scope.retailer
    }, '*');
  }

  async _setupNewOrder(needAddItem) {
    this._orderBeingCreated = true;
    await this._orderSetupService.createOrder(needAddItem);
    this._orderBeingCreated = false;
  }

  async _onInvitationAccepted() {
    await this._checkGroupOrder(false);

    await this._sendUserCartInfoToParent();
  }

  _onProductItemsChanged() {
    if (this._scope.isCart()) {
      this._rootScope.$broadcast(Constants.BroadcastMessages.CART_PAGE_REQUESTED);
    }
  }

  async _onCartChanged() {
    await this._checkGroupOrder();

    await this._sendUserCartInfoToParent();
  }

  async _onOwnershipTransferred(obj) {
    const message = this.$translate.instant('client.order.owner_shared');

    await this._messageService.showMessagePopup(`${message}`);
  }

  _onUserActiveAfterIdle(idleTimeInSecond) {

    if (idleTimeInSecond >= this.idleTimeBeforeRefreshing * 60) {
      window.location.reload(true);
    }
  }
}

export default ExternalStoreHandler;



// WEBPACK FOOTER //
// ./src/modules/shared/controllers/ExternalStoreHandler.js